import common from './common'
import featuresPay from './feature'

const zh = {
    featuresPay,
    common,
    SerialNumberDrawer: {
        productVariants: "产品/变体",
        serialNumber: "序列号",
        noProductsFound: "未找到产品",
        searchByProductSku: "按产品/SKU搜索",
        searchSerialNumbers: "搜索序列号",
        transactionDetails: "交易详情",
        notAvailable: "不适用",
        mainWarehouse: "主仓库"
    },
    new_build_banner: {
        title: '新版本:',
        is_available: '现已发布',
        fallback_title: '应用程序有新版本可用',
        desc: '刷新以获取最新功能和改进。',
        refreshing: '正在刷新…',
        refresh_now: '立即刷新',
        later: '稍后',
        you_are_on: "您当前使用的是"
    },
    short: {
        finance: '财务',
        stock: '库存'
    },
    onboarding: {
        welcome: '欢迎！',
        step: {
            product: {
                totalBreakdown: '总细目',
                overallFulfilment: '整体履行情况',
                totalShippedQty: '总发货数量',
                totalReceivedQty: '总接收数量',
                totalOrderedQty: '总订购数量',
                totalShippedOrdered: '总发货 / 订购',
                totalReceivedOrdered: '总接收 / 订购',
                viewQty: '查看数量',
                fetchingQty: '正在获取数量详情...',
                noStockInfo: '未找到库存信息',
                title: '已完成65%',
                description: '只剩下2个步骤即可开始您的巨大成功！',
                Warehouse: "仓库",
            },
            stock: {
                title: '95%几乎完成！',
                description: '只剩最后一步即可开启成功之旅！立即完成吧。'
            }
        },
        business: {
            title: '业务创建成功！',
            description: '太棒了！您的业务已成功注册'
        },
        product: {
            title: '添加您的第一个产品',
            description: '添加产品以开始记录库存',
            Warehouse: "仓库",
        },
        stock: {
            title: '尝试添加库存',
            description: '开始记录进出库存'
        },
        action: {
            add_business: {
                title: '创建业务',
                description: '想创建一个新业务吗？点击这里'
            },
            join_business: {
                title: '加入业务',
                description: '有邀请码吗？在这里加入'
            }
        }
    },
    business: {
        title: '选择业务、新建或加入',
        add_business: {
            title: '创建新业务',
            name: '业务名称',
            name_placeholder: '输入名称',
            category: '业务类别',
            category_placeholder: '选择类别',
            button: '创建业务'
        },
        edit_business: {
            title: '编辑业务'
        },
        join_business: {
            title: '加入业务',
            input_code: '请输入以下邀请码：',
            field_placeholder: '邀请码',
            confirm_title: '加入',
            confirm_text: '您将成为团队的一员 '
        },
        no_business: '暂无可用业务',
        create_or_join: '创建或加入业务',
        message: {
            saved: '业务已成功保存！'
        },
        settings: {
            isNegativeTransactionDisabled: '负库存交易',
            isNegativeTransactionDisabledHint: '通过开启此功能，您可以防止导致负库存的交易。',
            negativeStockError: '负库存交易已禁用'
        }
    },
    profile: {
        edit_profile: {
            title: '编辑个人资料',
            name: '姓名',
            name_placeholder: '输入姓名',
            email: '邮箱',
            phone_number: '电话号码'
        },
        message: {
            required_name: '姓名为必填项'
        }
    },
    product: {
        weightedAverageCost: '加权平均成本',
        weightedAverageValueLabel: '加权平均值',
        Product: '产品',
        hideZeroStock: '隐藏零库存',
        allVariants: '所有变体',
        choose_product: '选择产品',
        choose_product_empty: '选择产品并输入数量',
        choose_product_empty_manufacturing: '选择产品并输入生产数量',
        search: {
            placeholder: '按名称搜索',
            tooltip: '打开扫描仪',
            Warehouse: "仓库",
        },
        column: {
            image: '照片',
            name: '名称',
            price: '价格',
            buying_price: '成本价',
            selling_price: '销售价',
            sku: 'SKU',
            stock: '库存',
            quantity: '数量',
            latest_stock: '剩余',
            product_deleted: '产品已删除',
            info_not_found: '信息不可用',
            expired_date: '到期日期',
            invoice: '发票'
        },
        no_product: '暂无可用产品',
        no_product_subtitle: '添加您的第一个产品以开始跟踪库存、价格和销售。',
        create_first_product: '创建您的第一个产品',
        add_product: {
            sku: '产品编码',
            sku_placeholder: '产品编码，例如：12345',
            name: '产品名称',
            name_placeholder: '输入产品名称',
            initial_stock: '初始库存',
            initial_stock_placeholder: '输入初始库存',
            buying_price: '成本价',
            buying_price_placeholder: '输入成本价',
            selling_price: '销售价',
            selling_price_placeholder: '输入销售价',
            category: '类别',
            category_placeholder: '选择类别',
            add_selling_price: '添加批发价',
            expired_date: '到期日期',
            expired_date_placeholder: '选择日期',
            description: '描述',
            description_placeholder: '输入描述',
            custom_label: '属性',
            custom_label_placeholder: '输入键',
            add_custom_label: '添加更多属性',
            Warehouse: "仓库",
        },
        customerLabel: {},
        choose_selling_price: '选择销售价',
        selling_price: '销售价',
        total_product: '总产品数',
        total_quantity: '总库存',
        total_buying_price: '总成本价',
        total_selling_price: '总销售价',
        message: {
            required_name: '产品名称为必填项',
            required_sku: 'SKU为必填项',
            required_category: '类别为必填项',
            required_quantity: '初始库存为必填项',
            invalid_input_qty: '无效的库存数量',
            required_buying_price: '成本价为必填项',
            required_selling_price: '销售价为必填项',
            required_selling_price_name: '销售价格名称为必填项',
            required_selling_price_price: '销售价为必填项'
        },
        viewMore: '查看更多',
        WarehouseDetails: '仓库详情',
        WarehouseName: '仓库名称',
        AddWarehouse: '添加仓库',
        WarehouseQty: '仓库数量',
        Warehouse: '仓库',
        Warehouses: '仓库',
        Variants: '产品变体',
        VariantName: '变体名称',
        productVariant: '产品变体',
        AddVariant: '添加变体',
        TranferItem: '转移物品',
        AddUnit: '新单位',
        InitialStkWarehouse: '添加变体需要初始库存',
        InitialStockinwarehouse: '仓库中的初始库存',
        TotalQuantity: '总数量：',
        AddNote: '添加备注（成本价）',
        AddNotetitle: '添加备注',
        VariantSuccessMessage: '产品变体更新成功',
        Next: '下一步',
        Submit: '提交',
        INACTIVE: '未启用',
        errorone: '哎呀！请求的数量',
        errortwo: '与分配的仓库数量不匹配。请调整数量或补货。',
        SelectWarehouse: '选择仓库',
        SelectVariant: '选择变体',
        Discount: '折扣',
        DiscountDetails: '折扣详情',
        FinalPrice: '最终价格',
        DiscountType: '折扣类型',
        DiscountPer: '折扣百分比',
        DiscountValue: '折扣金额',
        Discountonprice: '价格折扣',
        Discountondiscount: '折上折',
        AdditionalDiscount: '额外折扣',
        SellingPrice: '销售价：',
        Save: '保存',
        OnOriginalPrice: '按原价',
        OnDiscountedPrice: '按折后价',
        columnSelector: {
            title: '显示列',
            columnsButton: '列',
            costPrice: '成本价',
            sellingPrice: '销售价',
            sku: 'SKU',
            warehouse: '仓库',
            categories: '分类',
            safetyStock: '安全库存',
            attributes: '属性',
            notes: '备注',
            description: '描述',
            more: '更多',
            attribute: '属性',
            attributesTitle: '属性',
            categoriesTitle: '分类',
            skuAliases: 'SKU 别名'
        }
    },
    note: {
        title: '备注',
        add: '添加备注',
        no_note: '暂无可用备注'
    },
    settings: {
        category: '类别',
        language: '语言',
        switch_business: '切换业务',
        currencySelect: '货币',
        languageChangeSuccess: '货币更新成功',
        languageChangeErrorMessage: '更新货币时出错',
        currencyAdded: "货币添加成功",
        currencyDelete: "货币删除成功",
        Selectyourpreferredlanguage: "选择您偏好的语言",
    },
    selectProductStock: '选择产品',
    category: {
        category_list: {
            title: '产品类别'
        },
        add_category: {
            button: '新建类别',
            title: '添加新类别'
        },
        edit_category: {
            title: '编辑类别'
        },
        name: '类别名称',
        name_placeholder: '输入类别名称',
        no_category: '没有可用类别'
    },
    staff: {
        add: '添加员工',
        edit: '编辑员工',
        access: {
            stock: '库存',
            add_product: '添加新产品',
            edit_product: '编辑产品',
            delete_product: '删除产品',
            view_capital_price: '查看成本价',
            add_category: '添加新类别',
            edit_category: '编辑类别',
            delete_category: '删除类别',
            add_supplier: '添加新供应商',
            edit_supplier: '编辑供应商',
            delete_supplier: '删除供应商',
            add_customer: '添加新客户',
            edit_customer: '编辑客户',
            delete_customer: '删除客户',
            add_staff: '添加员工',
            edit_staff: '编辑员工',
            delete_staff: '删除员工',
            change_business_profile: '更改业务资料',
            access_by_product_category: '按产品类别访问',
            no_category_message: '您还没有添加任何类别。请添加一个类别。',
            expenses: '支出',
            view_expenses: '查看支出',
            add_expenses: '添加支出',
            edit_expenses: '编辑支出',
            delete_expenses: '删除支出',
            warehouse: '仓库',
            add_new_warehouse: '添加新仓库',
            edit_warehouse: '编辑仓库',
            delete_warehouse: '删除仓库',
            transfer_warehouse: '转移仓库',
            transfer_warehouse_approval: '转移仓库审批',
            access_by_warehouse: '按仓库访问',
            no_warehouse_message: '您尚未添加任何仓库。请添加仓库列表。',
            purchase_order: "采购订单",
            purchase_order_creation: "采购订单创建",
            purchase_order_edit: "采购订单编辑",
            purchase_order_cancel: "采购订单取消",
            purchase_order_reopen: "采购订单重新打开",
            purchase_order_receive: "采购订单接收",
            sales_order: "销售订单",
            sales_order_creation: "销售订单创建",
            sales_order_edit: "销售订单编辑",
            sales_order_cancel: "销售订单取消",
            sales_order_reopen: "销售订单重新打开",
            sales_order_receive: "销售订单已发货",
            purchase_order_approval: "采购订单审批",
            sales_order_approval: "销售订单审批",
            can_do_available_warehouse: "可用仓库",
            add_batch: "批次创建审批"
            ,
            notification: '通知',
            staffNotification: '启用通知',
            assignee: "负责人",
        },
        no_staff: '没有可用员工'
    },
    code: {
        title: '新员工已添加！',
        subtitle: '分享以下邀请码以加入：',
        valid: '邀请码仅在48小时内有效',
        share: '分享到WhatsApp',
        copied: '已复制！',
        invalid: '无效的邀请码！'
    },
    history: {
        no_history: '没有历史记录。',
        detail: {
            remove: '删除历史记录',
            confirm: '此操作将影响现有库存、历史记录和报告。'
        },
        no_history_selected: "未选择任何历史记录",
        select_history_hint: "点击列表中的历史记录以查看详细信息",
        select_from_left: "从左侧面板选择",
    },
    supplier: {
        add: {
            title: '添加供应商'
        },
        edit: {
            title: '编辑供应商'
        },
        new: '新供应商',
        no_supplier: '没有可用供应商。',
        bank: {
            title: '银行信息'
        },
        note: '备注',
        form: {
            name: {
                label: '供应商名称',
                placeholder: '输入供应商名称',
                placheolder_not_mandatory: '输入名称',
                error: {
                    required: '名称不能为空'
                }
            },
            contact: {
                label: '联系电话',
                placeholder: '91934554432',
                error: {
                    required: '联系电话不能为空',
                    invalid: '号码无效，必须包含国家代码'
                }
            },
            bank_name: {
                label: '银行名称',
                placeholder: '输入银行名称'
            },
            bank_account_name: {
                label: '账户持有人姓名',
                placeholder: '输入账户持有人姓名'
            },
            bank_account_number: {
                label: '账户号码',
                placeholder: '输入账户号码'
            },
            note: {
                label: '备注',
                placeholder: '添加备注'
            },
            openingBalance: {
                addBtn: '添加期初余额',
                label: '期初余额',
                placeholder: '输入期初余额',
                error: {
                    negative: '期初余额不能为负数'
                }
            }
        },
        choose: '选择供应商'
    },
    customer: {
        add: {
            title: '添加客户'
        },
        edit: {
            title: '编辑客户'
        },
        new: '新客户',
        no_customer: '没有可用客户。',
        note: '备注',
        form: {
            name: {
                label: '客户姓名',
                placeholder: '输入客户姓名',
                placheolder_not_mandatory: '输入姓名',
                error: {
                    required: '姓名不能为空'
                }
            },
            contact: {
                label: '联系电话',
                placeholder: '91934554432',
                error: {
                    required: '联系电话不能为空',
                    invalid: '号码无效，必须包含国家代码'
                }
            },
            address: {
                label: '地址',
                placeholder: '输入地址'
            },
            note: {
                label: '备注',
                placeholder: '添加备注'
            },
            openingBalance: {
                addBtn: '添加期初余额',
                label: '期初余额',
                placeholder: '输入期初余额',
                error: {
                    negative: '期初余额不能为负数'
                }
            }
        },
        choose: "选择客户",
        report: {
            view: '查看买家报告',
            title: '客户报告',
            no_report: '所选日期没有买家报告。',
            column: {
                name: '姓名',
                total_transaction: '总交易数',
                total_amount: '总销售额',
                total_profit: '总利润'
            }
        }
    },
    confirm_delete: '您确定要删除这些数据吗？',
    report: {
        title: '报告'
    },
    accounting: {
        download_pdf_report: '下载PDF',
        title: '会计',
        view_report: '查看财务报告',
        dashboard_title: '财务报告',
        stats: '统计',
        accounting_report: '会计报告',
        filter: {
            date: {
                placeholder: '选择日期',
                submit: '应用',
                cancel: '重置筛选'
            },
            timeframe: {
                day: '每日',
                week: '每周',
                month: '每月',
                year: '每年'
            }
        },
        total_sales: '总销售额',
        total_purchases: '总采购额',
        total_profit: '总利润',
        total_expenses: '总支出',
        assets_value: '当前资产价值',
        total_current_cogs_value: '当前总COGS价值',
        current_asset_selling_price: '当前资产售价',
        total_selling_price: '总售价',
        table: {
            date: '日期',
            sales: '销售额',
            purchases: '采购额',
            profit: '利润',
            expenses: '支出'
        },
        no_data: '暂无可用数据'
    },
    stock_report: {
        title: '库存报告',
        view: '查看库存报告',
        no_report: '所选日期或员工没有库存记录。',
        allStaffPlaceHolder: '所有员工',
        column: {
            total_product: '当前产品类型',
            total_product_quantity: '总当前产品数'
        }
    },
    subscription: {
        paywall_small: {
            title: 'VIP功能',
            description:
                '此功能的试用期已结束。请通过订阅支持本地应用的开发。',
            button: '查看订阅计划'
        }
    },
    payment: {
        order: {
            title: '付款'
        }
    },
    imageUploadMessage: {
        uploadSize: '图片大小不得超过5MB！',
        failedMessage: '上传商品图片失败，请重试！',
        successUpload: '图片上传成功！',
        failedUIError: '删除图片失败，请重试！',
        SuccessErrorImage: '图片已成功删除！'
    },
    productColumns: {
        SKULabel: 'SKU',
        nameLabel: '产品名称',
        categoryLabel: '类别',
        BuyingPriceLabel: '进价',
        SellingLabel: '售价',
        StockLabel: '库存'
    },
    historyColumns: {
        Transactionlabel: '交易类型',
        Locallabel: '本地时间',
        Createdlabel: '创建人',
        Vendorlabel: '供应商名称',
        Buyerlabel: '客户名称',
        SKUlabel: 'SKU',
        Invoicelabel: '发票',
        Productlabel: '产品名称',
        Categorylabel: '类别',
        Buyinglabel: '进价',
        Sellinglabel: '售价',
        Initiallabel: '初始库存',
        Finallabel: '最终库存',
        Stocklabel: '库存变动'
    },
    stockReportColumns: {
        skuLabel: 'SKU',
        productNameLabel: '产品名称',
        categoryLabel: '类别',
        buyingPriceLabel: '进价',
        sellingPriceLabel: '售价',
        stockInLabel: '入库',
        stockOutLabel: '出库',
        remainingStockLabel: '剩余库存',
        openStockLabel: '初始库存',
        weightedAverageCost: '加权平均成本',
        weightedAverageCostLabel: '加权平均成本',
        weightedAverageValueLabel: '加权平均值'
    },
    accountingReportColumns: {
        dateRange: '日期范围',
        reportingPeriod: '报告期间',
        reportGenerate: '报告生成',
        warehouse: '仓库',
        labelDate: '日期',
        labelSales: '销售额',
        labelPurchases: '采购额',
        labelProfit: '利润',
        labelExpenses: '支出',
        reportOptions: '报告列',
        summaryCards: '摘要卡片',
        grandTotal: '总计',
        continued: '续',
        subtotal: '小计',
        page: '页'
    },
    customerReportColumns: {
        labelName: '姓名',
        labelTotalTransaction: '总交易数',
        labelTotalSales: '总销售额',
        labelTotalProfit: '总利润'
    },
    scannerDialog: {
        finished: '完成',
        reduce: '减少',
        successfull: '成功',
        searching: '搜索中...',
        title: '扫描器已激活，请对准条码！'
    },
    historyFilter: {
        SelectBuyer: '选择买家',
        SelectVendor: '选择供应商'
    },
    productStockFilter: {
        StockLowtoHigh: '库存从低到高',
        StockHightoLow: '库存从高到低',
        AlphabetAZ: '字母 A-Z',
        AlphabetZA: '字母 Z-A'
    },
    minimizeTitle: '扫描器已激活',
    security_guarantee: {
        title: '数据安全保障'
    },
    invoice: {
        invoicePlaceholder: '发票号码',
        invoiceTitle: '发票',
        manageInvoiceAddress: '管理发票地址',
        selectOrManageAddresses: '选择、编辑或创建自定义发票地址',
        useBusinessProfileAddress: '使用企业资料地址',
        noCustomAddressesFound: '未添加自定义地址',
        createCustomAddressDesc: '添加自定义结算或分支机构地址以打印在发票上，替代默认的企业资料数据。',
        defaultFromBusinessProfile: '企业资料默认',
        editInvoiceAddress: '编辑发票地址',
        createNewInvoiceAddress: '创建新发票地址',
        logoHeaderImage: '徽标 / 页眉图片',
        deleteInvoiceAddress: '删除发票地址？',
        deleteAddressConfirmText: '确定要删除此发票地址吗？此操作无法撤销。'
    },
    ManageInvoiceAddress: '管理发票地址',
    SelectOrManageAddresses: '选择、编辑或创建自定义发票地址',
    UseBusinessProfileAddress: '使用企业资料地址',
    CreateNewAddress: '创建新地址',
    UpdatingList: '正在更新列表...',
    NoCustomAddressesFound: '未添加自定义地址',
    CreateCustomAddressDesc: '添加自定义结算或分支机构地址以打印在发票上，替代默认的企业资料数据。',
    DefaultFromBusinessProfile: '企业资料默认',
    EditInvoiceAddress: '编辑发票地址',
    CreateNewInvoiceAddress: '创建新发票地址',
    LogoHeaderImage: '徽标 / 页眉图片',
    UploadingImage: '正在上传图片...',
    UploadImage: '上传图片',
    BusinessName: '企业名称',
    AddressDetails: '地址详情',
    PhoneNumber: '电话号码',
    EmailAddress: '电子邮件地址',
    DeleteInvoiceAddress: '删除发票地址？',
    DeleteAddressConfirmText: '确定要删除此发票地址吗？此操作无法撤销。',

    stocklowreport: {
        no_stocklowreport_one: '没有设置安全库存的商品。',
        no_stocklowreport_two: '请添加安全库存数量。',
        currentStock: '当前库存',
        safetyStock: '安全库存',
        pricing: '定价',
        costPrice: '成本价',
        sellingPrice: '销售价',
        productInfo: '产品信息',
        category: '类别',
        description: '描述',
        no_description: '未添加描述',
        variants: '变体',
        unitsOnHand: '现有库存单位',
        minimumThreshold: '最低阈值',
        adjust: '调整',
        all: '全部',
        lowStock: '库存不足',
        variantsDetails: '变体详情',
        qty: '数量',
        addSafetyStock: '添加安全库存',
        searchByNameSku: '按名称/SKU搜索',
        safetyStockShort: '安',
        warehouseSafetyStock: '仓库安全库存'
    },
    low_alert_stock: '输入安全库存数量',
    lowStockAlertNotify: '当库存低于设定数量时，您将收到通知',
    applyButtonStockAlert: '应用',
    cancelButtonStockAlert: '取消',
    searchProductLabel: '搜索产品...',
    successfullyAddedSafetyStock: '成功更新安全库存',
    safety_Stock: '安全库存',
    safety_stock_placeholder: '输入安全库存',
    lowStockDetailsInfo: {
        ProductCode: '产品代码',
        SafetyStock: '安全库存',
        Stock: '库存',
        CostPrice: '成本价',
        SellingPrice: '售价',
        Category: '类别',
        Description: '描述',
        ExpirationDate: '到期日期'
    },
    CustomLang: {
        Attribute: '属性',
        AddAttribute: '添加属性',
        EditAttribute: '编辑属性',
        CustomLabePlaceholder: '输入属性名称',
        CustomLabePlaceholderSelect: '选择类型',
        AddMoreAttribute: '添加更多属性',
        ItemAttribute: '商品属性',
        TableName: '名称',
        TableType: '类型',
        TableAction: '操作',
        TableDelete: '删除',
        TableEdit: '编辑',
        deleteMessage: '属性已成功删除',
        editSuccessMessage: '属性已成功更新',
        AddSuccessMessage: '属性已成功添加',
        AddAtt: '添加',
        EditAtt: '编辑',
        SubmitAtt: '提交中...'
    },
    Expenses: {
        ExpensesTitle: '支出',
        AddExpenses: '添加支出',
        ExpenseCategory: '支出类别',
        NoExpenseCategory: '没有支出类别',
        AddExpenseCategory: '添加支出类别',
        SelectExpenseCategory: '选择支出类别',
        NoExpenses: '没有支出',
        ExpensesSuccess: '支出创建成功',
        ExpensesSuccessEdit: '支出更新成功',
        ExpensesCategoryName: '支出类别名称',
        ExpensesSuccessDelete: '支出删除成功',
        AddNEC: "添加新费用类别",
        NC: "新费用类别",
        EditNEC: "编辑费用类别"
    },
    Manufacturing: {
        ProducedProduct: "产出产品",
        QuantityManufactured: "制造数量",
        UnitCost: "单位成本",
        RawMaterialsTotal: "原材料总计",
        TotalManufacturingCost: "总制造成本",
        NoRawMaterialsConsumed: "未消耗原材料。",
        CostBreakdown: "成本明细",
        GeneratedBatch: "生成批次",
        StoredBinLocation: "存储库位",
        NoManufacturingTransactionsFound: "未找到制造交易记录",
        AddManufacture: '添加制造详情',
        Manufacturing: '制造',
        RawMaterials: '原材料',
        AdditonCosts: '附加成本',
        RawMaterial: '原材料',
        AdditonCost: '附加成本',
        TotalCost: '总成本',
        AddRawMaterial: '为其添加原材料',
        AddAdditonCost: '为其添加附加成本',
        AddMore: '添加更多',
        Add: '添加',
        Update: '更新',
        Updating: '提交中...',
        ProductRequired: '产品为必填项',
        QuantityRequired: '数量为必填项',
        ChargeRequired: '费用为必填项',
        EstimatedCostRequired: '预计成本为必填项',
        PurchasePriceRequired: '采购价格为必填项',
        SelectCharge: '选择费用',
        EstimatedCost: '预计成本',
        SelectProduct: '选择产品',
        Quantity: '数量',
        ManufactureDetails: '制造详情',
        BuyingPrice: '进价',
        LabourCharge: '人工费',
        ElectricityCost: '电费',
        PackagingCharge: '包装费',
        LogisticCost: '物流费',
        OtherCharges: '其他费用',
        Save: '保存详情',
        PurchasePrice: '采购价格',
        Date: '日期',
        For: '用于',
        PurchaseRate: '采购率（价格）',
        Scrolltoloadmore: '向下滚动加载更多...',
        Noproductsfound: '未找到产品',
        ManufacturingQuantity: '制造数量',
        ManufactureAddedSuccess: '制造详情更新成功'
    },
    Warehouses: {
        transferOrder: '转移物品',
        AddTransferOrder: '添加转移物品',
        NewWarehouse: '新仓库',
        newHead: '开始管理多个仓库！',
        headTwo: '无缝跟踪并管理您在多个仓库中的库存',
        EnableWarehouse: '启用仓库',
        EnableWarehouse2: '启用仓库',
        OrganizationPrimary: '组织的主要仓库',
        Edit: '编辑',
        AreEnableWarehouse: '确定要启用仓库吗？',
        Confirm: '确认',
        Cancel: '取消',
        WarehouseCreatedSuccessfully: '仓库创建成功',
        MarkAsOP: '标记为组织主要仓库',
        MarkAsInAct: '标记为未启用',
        MarkAsAct: '标记为启用',
        MarkedAsInactive: '仓库已成功标记为未启用',
        MarkedAsActive: '仓库已成功标记为启用',
        MarkedAsOP: '仓库已成功标记为主要仓库',
        WareDeletedSuccess: '仓库删除成功',
        SuccessfullyUpdatedWarehouse: '仓库更新成功',
        SuccessfullyCreatedWarehouse: '仓库创建成功',
        EditWarehouse: '编辑仓库',
        AddWarehouse: '添加仓库',
        WarehouseNameIsRequired: '仓库名称为必填项',
        EnterWarehouseName: '输入仓库名称',
        EnterEmail: '输入邮箱',
        EnterPhoneNumber: '输入电话号码',
        Location: '位置...',
        name: '仓库名称',
        email: '邮箱',
        phoneNumber: '电话号码',
        location: '位置',
        ViewProducts: '查看产品',
        PageTitle: '仓库',
        noWarehouse: "没有仓库符合您的搜索"
    },

    Assets: {
        headerTitle: '资产',
        addAssetMessage: '在此添加资产。要将资产分配给员工，请转到员工的个人资料。',
        addAsset: '添加资产',
        editAsset: '编辑资产',
        assetCode: '资产编码',
        assetName: '资产名称',
        assetCategory: '资产类别',
        assetType: '资产类型',
        serialNumber: '序列号',
        location: '位置',
        condition: '状态',
        selectCondition: '选择状态',
        fair: '一般',
        good: '良好',
        excellent: '优秀',
        poor: '差',
        notes: '备注',
        submit: '提交',
        submitting: '提交中',
        noCategory: '无类别',
        selectCategory: '选择类别',
        addAssetCat: '添加资产类别',
        addAssetCatName: '资产类别名称',
        edit: '编辑',
        status: '状态',
        createdAt: '创建时间',
        viewAsset: '查看资产',
        assignAsset: '分配资产',
        conditionRet: '状态（归还时）',
        searchSelectAssets: '搜索/选择资产',
        assetAssigned: '资产分配成功',
        assetReturned: '资产归还成功',
        selectAnAsset: '请选择资产',
        action: '操作',
        noAssetAssigned: '未分配资产',
        reAssigned: '重新分配',
        assignedAssetsList: '已分配资产列表',
        viewHistory: "查看历史",
        history: "资产历史",
        loadingHistory: "正在加载历史...",
        loadingMore: "正在加载更多...",
        dateTime: "日期和时间",
        staff: "员工",
        AssignedBy: "分配者",
        assign: "分配",
        return: "归还",
        unknown: "未知",
        noHistory: "此资产没有可用的历史记录。",
        enterReturnNote: "输入归还备注",
        returnNote: "归还备注",
        enterAssignNote: "输入分配备注",
        assignNote: "分配备注",
        AddNAC: "添加新资产类别",
        EditNAC: "编辑资产类别",
        others: "其他"
    },
    LedgerTransaction: {
        ledgerDetails: '账簿详情',
        productName: '产品名称',
        totalQty: '总数量',
        date: '日期',
        receivedAmt: '收到金额',
        paid: '已支付',
        discount: '折扣',
        balance: '余额',
        more: '更多',
        total: '总计',
        ledgerupdatedsuccessfully: '账簿更新成功',
        ledgeraddedsuccessfully: '账簿添加成功',
        viewLedger: '查看账簿',
        edit: '编辑',
        create: '创建',
        Recieved: '收到 [入库]',
        payMode: '支付方式',
        Refno: '参考号'
    },
    ExtraField: {
        attachment: '附件',
        acceptOnlyImg: '仅支持图片格式。',
        addAttribute: '添加属性',
        acceptImgAndDoc: "接受图像和文档",
    },
    phoneInvoiceDownload: {
        Variant: '变体',
        Warehouse: '仓库',
        Bin: '储位',
        Batch: '批次',
        Attributes: '属性'
    },
    ImportExcel: {
        ImportStockfromExcel: "从 Excel 导入库存",
        DragDrop: "将填写好的 Excel 文件拖放到此处，或点击浏览",
        DT: "下载模板",
        GB: "返回",
        Downloading: "正在下载...",
        ChangeFile: "更换文件",
        ReadingExcelfile: "正在读取 Excel 文件...",
        Processing: "处理中...",
        submitUpdateStock: "提交并更新库存",
        downloadLatestTemplate: "下载最新模板",
        loginRequired: "需要登录"
    },
    stockForm: {
        recordPaymentNow: "立即记录付款",
        recordPaymentDescCustomer: "输入客户支付的金额",
        recordPaymentDescSupplier: "输入供应商支付的金额",
        managePayments: "管理付款",
        invoice: "发票",
        challan: "送货单",
        recordPayment: "记录付款",
        payableAmount: "应付金额",
        paidAmount: "已付金额",
        paymentMethod: "付款方式",
        paymentDate: "付款日期",
        reference: "参考",
        billId: "账单号",
        importExcel: "从 Excel 导入",
        noThanks: "不，谢谢",
        checkHistory: "查看历史",
        wantViewHistory: "您想查看历史记录吗？",
        enterPayable: "输入应付金额",
        enterPaid: "输入已付金额",
        selectPayment: "选择付款方式",
        attachment: "附件",
        note: "备注"
    },
    HistoryEdit: {
        products: "产品",
        add_product: "添加产品",
        paidAmountInvalidMessage: "已付金额不能大于应付金额",
        removingText: "删除此产品将撤销在此交易期间所做的库存更改。",
        remove: "删除"
    },
    ExcelProduct: {
        uploadFile: "上传文件",
        dragDrop: "拖放 Excel 文件或点击上传。",
        parsingFile: "正在解析文件",
        fileSelected: "文件已选择",
        reviewImportedData: "请查看下面导入的数据。可能的情况下会自动匹配列。",
        changeFile: "更换文件",
        back: "返回",
        invalidFileType: "请上传有效的 Excel 文件（.xlsx 或 .xls）",
        parseExcelError: "Excel 解析错误：",
        noData: "上传的 Excel 文件中没有数据。",
        failedToRead: "无法读取 Excel 文件，请重试。",
        Nodata: "无数据",
        unableToRead: "无法读取文件。",
        buyingMustNumber: "进价必须是数字",
        sellingMustNumber: "售价必须是数字",
        mustBeNumber: "必须是数字",
        bulkUploadfailed: "批量上传失败",
        importFromExcel: "从 Excel 导入",
        generating: "生成中...",
        downloadTemplate: "下载模板",
        uploading: "上传中...",
        done: "完成",
        requiredField: "{field} 为必填项",
        bulkUpload: "批量上传",
        duplicateSku: "发现重复的SKU",
        uploadedSuccessfully: "所有产品已成功上传！",
        uploadCompleteIssues: "上传完成但存在问题",
        uploaded_products: "已上传 {count} 个产品。",
        failed_products: "{count} 个失败。",
        failed_items: "失败项目："
    },
    Discount: {
        overallDiscount: "整体折扣",
        final: "最终合计",
        balanceDue: "应付余额",
        tax: "税"
    },
    ProductForm: {
        barcodeQuantity: "输入条码数量",
        baseUnit: "基础单位（主要）",
        addSecondaryUnit: "添加次级单位？",
        selectUnit: "选择单位",
        subUnitDetails: "次级单位详情",
        subUnit: "次级单位",
        selectSubUnit: "选择次级单位",
        conversionRate: "换算率",
        exampleLogic: "示例逻辑：",
        example: "如果您以盒装销售钢笔，请将基础单位设置为盒，并添加一个换算率为50的次级单位（件）。这意味着1盒包含50件。",
        basePrice: "基础价格"
    },
    barcode: {
        settings: '条码设置',
        labelSize: '标签尺寸',
        customSize: '自定义尺寸...',
        widthMm: '宽度 (mm)',
        heightMm: '高度 (mm)',
        showPrice: '在标签上显示售价',
        noPrices: '未为此产品配置售价。',
        preview: '预览',
        generate: '生成',
        label: '标签',
        singlePage: '单页',
        downloadOptions: '下载选项',
        chooseLayout: '选择条码布局',
        allInSinglePage: '将所有条码添加到单页中。',
        allInA4Grid: '全部在一页中',
        allInA4GridSub: '将所有条码排列在 A4 网格中',
        onePerPage: '每页一个',
        onePerPageSub: '每个条码位于其自己的标签页'
    },

    TransferItem: {
        transferItem: "物品转移",
        Date: "日期",
        Reason: "原因",
        enterReason: "输入原因",
        Name: "名称",
        QuantityTransfered: "转移数量",
        SWarehouse: "源仓库",
        SelectSWarehouse: "选择源仓库",
        DWarehouse: "目标仓库",
        SelectDWarehouse: "选择目标仓库",
        CreatedBy: "创建者",
        CreatedTime: "创建时间",
        UpdatedTime: "更新时间",
        NoOrderFound: "未找到订单",
        New: "新建",
        WarehouseItemTransfer: "仓库物品转移",
        TotalTransfers: "总转移数",
        EnterReason: "输入原因",
        ItemDetails: "物品详情",
        CurrentAvailable: "当前可用",
        TransferQty: "转移数量",
        SStock: "源库存",
        DStock: "目标库存",
        addDescription: "添加物品描述",
        selectVariant: "选择变体",
        addNewRow: "添加新行",
        typeOrSelectItem: "输入以搜索",
        scrollToLoadMore: "滚动加载更多",
        noProductsFound: "未找到产品",
        selectWarehouse: "选择仓库"
    },
    Sku: {
        searchSelectProduct: "搜索 / 选择产品",
        searchSelectSku: "搜索 / 选择 SKU",
        noSkuFound: "未找到 SKU"
    },
    HistoryPage: {
        addFilter: "添加筛选",
        filtersActive: "所有筛选已启用",
        noProducts: "没有产品",
        download: "下载",
        recentlyUpdated: "最近更新",
    },
    StockPage: {
        challanNumber: "单据编号",
        subTotal: "小计",
        totalTaxes: "总计与税费",
        taxInclusive: "含税",
        discountedValue: "折扣后金额",
        taxValue: "税额",
        totalAmount: "总金额",
        close: "关闭",
        addTax: "添加税费",
        label: "标签",
        enterLabel: "输入标签",
        taxRate: "税率",
        enterTaxRate: "输入税率",
        selectTaxRate: "选择税率",
        addNewTax: "添加新税率",
        discountProducts: "折扣金额（产品）",
        taxProducts: "税额（产品）",
        clickAddPayment: "点击添加付款",
        paidGreaterPayable: "已付款金额不能大于应付款金额",
        vendorCompulsory: "记录付款时必须选择供应商",
        customerCompulsory: "记录付款需要选择客户",
        updateInvoiceFormat: "更新发票格式",
        updateChallanFormat: "更新单据格式",
        addPrefix: "添加前缀",
        prefix: "前缀"
    },
    EditHistoryPage: {
        search_by_notes: "按备注搜索",
        alertMessage: "此更改仅记录在历史中，不会影响当前库存。",
        paymentDetails: "付款详情",
        units: "单位",
        customLabels: "自定义标签",
        value: "值",
        Order_Info: "订单信息",
        percentage: "百分比",
        Stock_updates_on_submit: "提交时更新库存",
        Summary: "摘要"

    },
    historyCard: {
        paid: "已付款",
        partiallyPaid: "部分付款",
        billDate: "账单日期",
        productDetails: "产品详情",
        paymentsHistory: "付款历史",
        updatePayment: "更新付款",
        discounts: "折扣",
        inclusive: "(含税)",
        discountOverall: "折扣金额（总计）",
        dueAmount: "应付金额",
        enterPaid: "输入已付款金额",
        enterReference: "输入参考号",
        enterNote: "输入备注",
        enterInvoice: "输入发票",
        enterChallan: "输入单据",
        edit: "已编辑"
    },
    printInvoice: {
        billTo: "账单至",
        ref: "参考编号",
        mode: "方式",
        date: "日期",
        amount: "金额",
        totalPaid: "已付总额"
    },
    Contact: {
        supplier_required: "入库需要供应商",
        customer_required: "出库需要客户",
        key: "键",
        editHistory: "编辑历史",
        loading: "加载中..."
    },
    AW: {
        availablewarehouse: "可用仓库",
        visibilityManagement: '可见性管理',
        availablewarehouses: "可用仓库",
        Active: "活跃",
        LWarehouse: "正在加载仓库...",
        NWForthisProduct: "未找到此产品的仓库。",
        of: "的",
        WarehouseAvailabilty: "仓库可用性",
    },
    Currency: {
        searchCurrency: "搜索货币...",
        addCurrency: "添加货币",
        addNewCurrency: "添加新货币",
        editCurrency: "编辑货币",
        currencySymbol: "货币符号",
        currencyName: "货币名称",
        enterCurrencySymbol: "输入货币符号",
        enterCurrencyName: "输入货币名称"
    },
    NewReportLang: {
        DM: "每日移动",
        WR: "仓库报告",
        PDM: "产品每日移动",
        TBP: "总购买价格",
        TPQ: "总产品数量",
        TP: "总产品",
        CS: "当前库存",
        IV: "库存价值",
        DA: "每日平均",
        TSI: "总入库",
        TSO: "总出库",
        TOR: "周转率",
        Tv: "总价值",
        AST: "活跃SKU跟踪",
        UT: "跟踪单位",
        SL: "库存水平",
        Value: "价值",
        IO: "入库/出库",
        T: "周转",
        unitsD: "单位/天",
        Sort: "排序",
        Sort_by: "按排序",
        Units_available: "可用单位",
        Units_unavailable: "不可用单位",
        Current_assets: "流动资产",
        Search: "搜索",
        available: "可用",
        assigned: "已分配",
        AYSWD: "确定要删除吗？",
        PTS: "仓库转移成功",
        AUS: "资产更新成功",
        ACS: "资产创建成功",
        VSP: "查看销售价格",
        HUS: "历史记录更新成功",
    },
    ReplacementReturn: {
        selectProduct: "请选择产品",
        selectReplacementProduct: "请选择至少一个替换产品",
        validQuantity: "请输入有效的退货数量",
        replacedSuccessfully: "产品替换成功",
        returnSuccessfully: "产品退货成功",
        failedProcess: "处理失败，请重试。",
        return: "退货",
        replace: "替换",
        typeSelectProduct: "输入或选择产品...",
        returnQuantity: "退货数量",
        enterQuantity: "输入数量",
        replacementDate: "替换日期",
        returnDate: "退货日期",
        chooseCustomer: "选择客户",
        additionalNotes: "添加额外备注...",
        replacementProducts: "替换产品",
        addProducts: "添加更多产品",
        tapSelect: "点击从可用产品中选择",
        currently: "当前",
        item: "件",
        items: "件",
        selected: "已选",
        selectedItems: "已选项目",
        hideDetails: "隐藏更多详情",
        showDetails: "显示更多详情",
        product: "产品",
        priceLevel: "选择价格级别",
        customPrice: "输入自定义价格",
        noReplaceHistory: "未找到替换历史记录",
        replaceReturn: "更换与退货",
        replaceReturnHistory: "更换与退货记录"
    },
    OtherComponent: {
        mfgHistoryTitle: "制造历史",
        mfgHistoryDesc: "跟踪制造 of 库存产品",
        dailyOperation: "日常运营",
        freqUsed: "用于快速更新记录的常用操作",
        manageCategory: "管理分类",
        organizeCaterory: "整理和管理产品、费用和资产分类",
        businessRecord: "业务记录",
        organizeRecord: "整理和管理您的业务记录",
        trackHistory: "跟踪历史",
        completeTracking: "用于审计和跟踪的完整历史记录",
        Verifyinventorycount: "验证库存数量",
        Exchangerates: "汇率",
        Productiontracking: "生产跟踪",
        Fixedassetregister: "固定资产登记册",
        Storagelocations: "存储位置",
        warehouseAvailability: '仓库级产品可用性',
        Logreviewspend: "记录和审查支出",
        Productgroupings: "产品分组",
        Classifyexpenditures: "支出分类",
        Assetclassification: "资产分类",
        Manageexchanges: "管理汇率",
        Returnauditlog: "退货审计日志",
        Interlocationmoves: "位置间移动",
        Manageoperationscategoriesrecordsandhistory: "管理运营、分类、记录和历史"
    },
    no_permission_dialog: {
        title: '无权限',
        historyDescription: "您无权查看交易历史。请联系您的管理员。",
        replacementHistoryDescription: "您无权查看替换与退货历史。请联系您的管理员。",
        transferHistoryDescription: "您无权查看转仓历史。请联系您的管理员。"
    },
    OthersHistory: {
        title: "管理历史",
        transferHistory: "管理转仓历史",
        transactionHistory: "管理交易历史",
        replacementHistory: "管理替换与退货历史"
    },
    catalog: {
        allCategories: "All",
        category: "Category",
        purchaseDescription: "浏览并购买企业分享的产品。",
        description: "浏览企业分享的产品。",
        productsAvailable: "可用产品",
        noImageAvailable: "暂无图片",
        productDetails: "产品详情",
        inStock: "有库存",
        availableVariants: "可用选项",
        options: "选项",
        orders: "订单"
        ,
        searchProducts: "搜索产品...",
        noProductsFound: "未找到产品",
        tryDifferentKeyword: "尝试使用其他关键词搜索",
        variants: "变体",
        stock: "库存",
        cart: "购物车",
        products: "产品",
        viewCart: "查看购物车",
        backToProducts: "返回产品",
        yourCart: "您的购物车",
        clear: "清空",
        cartEmpty: "购物车为空",
        cartEmptyDesc: "浏览目录并添加您想订购的产品。",
        browseProducts: "浏览产品",
        selectedItems: "已选商品",
        itemInCart: "件商品在购物车中",
        itemsInCart: "件商品在购物车中",
        customerDeliveryDetails: "客户与配送信息",
        fullName: "姓名",
        enterFullName: "请输入您的姓名",
        deliveryAddress: "配送地址",
        addressPlaceholder: "街道、楼栋、城市、邮编...",
        orderNote: "订单备注（可选）",
        orderNotePlaceholder: "特殊说明或配送备注...",
        paymentMode: "付款方式",
        subtotal: "小计",
        items: "件",
        totalAmount: "总金额",
        orderOnWhatsApp: "通过WhatsApp下单 📲",
        orderPlaced: "订单已成功提交！🎉",
        orderPlacedDesc: "您的订单已记录，WhatsApp已打开。",
        continueShopping: "继续购物 🛍️",
        cartEmptyTitle: "购物车为空",
        cartEmptyToast: "请先将产品添加到购物车。",
        incompleteTitle: "信息不完整",
        incompleteToast: "请在下单前填写所有必填项。",
        nameRequired: "姓名为必填项",
        addressRequired: "配送地址为必填项",
        catalogUnavailable: "目录暂不可用",
        catalogUnavailableDesc: "此目录当前未激活，请联系商家。",
        invalidCatalogLink: "无效的目录链接 🚫",
        invalidCatalogDesc: "此目录页面缺少必要信息。",
        missing: "缺失",
        catalogSlug: "目录标识",
        goBackHome: "返回首页",
        inventoryManagement: "库存管理与开票 🚀 Simply",
        enter: "输入",
        select: "选择",
        // Catalog Order translations
        catalogOrders: '目录订单',
        pending: '待处理',
        converted: '已转换',
        cancelled: '已取消',
        totalRevenue: '总价值',
        totalCatalogOrders: '在线订单总数',
        convertToSalesOrder: '转换为销售订单',
        date: '日期',
        status: '状态',
        action: '操作',
        searchOrders: '搜索客户或电话...',
        noMatchingOrders: '未找到匹配的订单',
        noStatusOrders: '未找到{status}订单',
        tryDifferentSearch: '尝试使用不同的客户名称或电话号码进行搜索。',
        noOrdersWithStatus: '目前没有{status}状态的订单。',
        noOrdersYet: '暂无目录订单',
        noOrdersDescription: '来自您在线目录的订单将显示在这里。',
        guestCustomer: '访客客户',
        item: '商品',
        moreItems: '+{count}个更多',
        viewDetails: '查看详情',
        viewSalesOrder: '查看销售订单',
        cancelOrder: '取消订单',
        confirmCancelTitle: '取消目录订单？',
        confirmCancelOrder: '您确定要取消此订单吗？此操作无法撤销。',
        keepOrder: '否，保留订单',
        confirmCancelAction: '是，取消订单',
        orderNotFound: '未找到目录订单',
        orderNotFoundDescription: '找不到此订单，或者您可能没有查看权限。',
        backToCatalogOrders: '返回目录订单',
        placedOn: '下单时间',
        totalItems: '商品总数',
        orderedProducts: '已订购产品',
        itemDetails: '商品详情',
        quantity: '数量',
        unitPrice: '单价',
        total: '总计',
        variant: '变体',
        customerInformation: '客户信息',
        additionalFields: '附加字段',
        fields: '字段',
    },
    stockNew: {
        Npay: "尚未添加任何产品",
        emptydesc: "从您的目录中选择一个产品，并输入进货数量以记录库存。",
        tipText: "提示：您也可以上传 excel 文件",
        OT: "订单总额",
        Collapse: "折叠"
    },
    deleteBulk: {
        Bulkoperation: "批量操作",
        Applyproducts: "对多个产品应用操作",
        Bulkupload: "批量上传",
        ImportCSVfile: "通过 Excel 或 CSV 文件导入产品",
        or: "或",
        Bulkdelete: "批量删除",
        Permanentlyallproducts: "永久移除所有产品",
        IrrText: "批量删除不可逆。请先导出备份（如需要）。",
        SeP: "已选产品",
        sP: "选择产品",
        DA: "全部删除",
        DP: "删除产品",
        sL: "全选",
        ASDE: "确定要删除除",
        ASDAllP: "确定要删除所有产品吗？",
        ASD: "确定要删除",
        products: "个产品",
        TACBU: "此操作无法撤销。",
        LP: "正在加载产品...",
        FM: "正在加载更多...",
        NPF: "未找到产品。",
        LMP: "正在加载更多产品..."
    },
    NewVariantModal: {
        Definevariantsassign: "定义变体并分配数量",
        Nothingallocated: "未分配任何数量",
        Overallocated: "超额分配",
        Fullyallocated: "已完全分配",
        Overby: "超额",
        Allvariantsneedaname: "所有变体都需要名称。",
        Reducequantities: "减少数量。",
        Overallocatedby: "超额分配",
        Quantitiesmustmatchthetotalavailability: "数量必须与总可用量匹配。",
        Allocatequantitiesacrosswarehouses: "跨仓库分配数量",
        Notfullydistributed: "未完全分配：",
        remaining: "剩余",
        Qty: "数量",
        Inactive: "未激活",
        left: "剩余"
    },
    ProductFormNew: {
        BasicInfo: "基本信息",
        ProductImage: "产品图片",
        Images: "图片",
        Pricing: "定价",
        Everypriceneedsbothalabelandanamount: "每个价格都需要标签和金额",
        AddalabellikeWholesaleorRetailtoidentifythisprice: '添加类似“批发”或“零售”的标签来标识此价格',
        AddMultiplePrice: "添加多个价格",
        NoPhotosLetAiFind: "没有照片？让 AI 查找商品图片",
        AddProductImagesTitle: "添加商品图片",
        ChooseHowToAddPhotos: "选择为此商品添加照片的方式：",
        SearchWithAi: "使用 AI 搜索",
        SearchWithAiDesc: "使用 AI 自动查找并选择商品图片",
        FilesFileExplorer: "文件（文件资源管理器）",
        FilesFileExplorerDesc: "直接从您的电脑中选择图片",
        AiProductImageFinder: "AI 商品图片查找器",
        AiProductImageFinderDesc: "为您的商品搜索并选择图片",
        TypeProductNamePlaceholder: "输入商品名称...",
        SearchForYourProduct: "搜索您的商品",
        SearchForYourProductHint: `尝试品牌或商品名称，例如 "Kirkland 米诺地尔"`,
        ImagesSelected: "张图片已选择",
        AddSelected: "添加所选"
    },
    AttributeNewCustom: {
        Defineanewcustomfield: "定义新的自定义字段",
        AttributeName: "属性名称",
        DataType: "数据类型",
        Noattributesfound: "未找到属性",
        ManageAttributes: "管理属性",
        Editordeleteexistingattributes: "编辑或删除现有属性",
        UpdateAttribute: "更新属性",
        Saving: "保存中..."
    },
    NewExpenses: {
        Noexpensesyet: "暂无支出",
        Addyourfirstexpensetostarttrackingyourspending: "添加您的第一笔支出，开始跟踪您的消费。",
        TOTALEXPENSES: "总支出",
        ENTRIES: "条目",
        BYCATEGORY: "按类别",
        Nocategoriestodisplay: "没有可显示的类别",
        DateanfTime: "日期和时间"
    },
    PurchaseSales: {
        CancelOrder: "取消订单",
        ReopenOrder: "重新打开订单",
        Reopen: "重新打开",
        ConfirmCancelOrder: "您确定要取消此订单吗？",
        ConfirmReopenOrder: "您确定要重新打开此订单吗？",
        OrderCancelledSuccessfully: "订单已成功取消。",
        OrderReopenedSuccessfully: "订单已成功重新打开。",
        CancelledBy: "取消人",
        Cancelled: "已取消",
        ConvertPriceBasedOnUnitConversion: "根据单位换算转换价格",
        MarkPaymentAsPending: "将付款标记为待处理",
        PendingReceivableDesc: "金额已记录为应收款。收到款项时记录付款。",
        PendingPayableDesc: "金额已记录为应付款。付款时记录付款。",
        SelectCustomerFirst: "请先选择客户",
        SelectSupplierFirst: "请先选择供应商",
        SelectItemsFirst: "请先选择至少一个商品",
        PaymentMarkedPendingDesc: "付款已标记为待处理。取消勾选“将付款标记为待处理”以立即记录付款。",
        SelectCustomerAndItemFirst: "请先选择客户和至少一个项目",
        SelectSupplierAndItemFirst: "请先选择供应商和至少一个项目",
        SelectCustomerProductFirst: "请先选择客户和产品",
        SelectSupplierProductFirst: "请先选择供应商和产品",
        Receivables: "应收账款",
        Payables: "应付账款",
        AccessDenied: "访问被拒绝",
        YouDonthaeP: "您没有权限查看此页面。如果您认为这是错误，请联系您的管理员。",
        purchase: "采购",
        sales: "销售",
        Areyousureyouwantto: "您确定要",
        Thisactionwillupdateitsstatus: "此操作将更新其状态。",
        ReasonOPtional: "原因（可选）",
        Enterareasonfor: "请输入原因",
        optionalDot: "(可选)...",
        Reject: "拒绝",
        ConfirmOrder: "确认订单",
        RejectOrder: "拒绝订单",
        Previous: "上一个",
        First: "第一个",
        Order: "订单",
        Items: "商品",
        Memo: "备注",
        SelectDateRange: "选择日期范围",
        List: "列表",
        Board: "看板",
        View: "查看",
        OrderType: "订单类型",
        SelectOrderType: "选择订单类型",
        CreateSalesOrder: "创建销售订单",
        CreatePurchaseOrder: "创建采购订单",
        successfully: "成功",
        ManageAttachments: "管理附件",
        Stockoutitemsimmediatelyaftersaving: "保存后立即出库商品。",
        Stockinitemsimmediatelyaftersavingthisorder: "保存此订单后立即入库商品。",
        ViewAttachments: "查看附件",
        MemoAttachments: "备注与附件",
        ReceivedDate: "接收日期",
        ShippedDate: "发货日期",
        OrderDate: "订单日期",
        OrderDetails: "订单详情",
        Subtotal: "小计",
        OrderSummary: "订单摘要",
        AddItem: "添加商品",
        NewSalesOrder: "新建销售订单",
        NewPurchaseOrder: "新建采购订单",
        Createandmanageyour: "创建和管理您的",
        orders: "订单",
        Removeitem: "移除商品",
        UnitPrice: "单价",
        PurchaseOrder: "采购订单",
        SalesOrder: "销售订单",
        PurchaseInvoice: "采购发票",
        SalesInvoice: "销售发票",
        PurchaseOrdernotfound: "未找到采购订单",
        Approve: "批准",
        MarkasShipped: "标记为已发货",
        MarkasReceived: "标记为已接收",
        Marking: "标记中...",
        PartiallyShip: "部分发货",
        PartiallyReceive: "部分接收",
        Deleting: "删除中...",
        Transaction: "交易",
        Details: "详情",
        Item: "商品",
        Received: "已接收",
        Shipped: "已发货",
        Ordered: "已订购",
        units: "单位",
        Overalldiscount: "总折扣",
        Transactions: "交易记录",
        Notransactionsfound: "未找到交易",
        OrderedQty: "订购数量",
        Totalqty: "总数量",
        StockingOut: "出库中...",
        StockingIn: "入库中...",
        thiorderUpdateStuau: "此订单？此操作将更新其状态。",
        TransactionDetails: "交易详情",
        Fetchingtransactiondetails: "正在获取交易详情...",
        Nodetailsfoundforthistransaction: "未找到此交易的详情。",
        TotalBreakDown: "总额明细",
        ChangeAmount: "找零金额",
        Attachments: "附件",
        PoNumber: "采购订单号",
        SoNumber: "销售订单号",
        partner: "合作伙伴",
        EditPurchase: "编辑采购",
        EditSales: "编辑销售",
        PurchaseOrderDetails: "采购订单详情",
        SalesOrderDetails: "销售订单详情",
        OrderTypePrepaid: "预付款",
        OrderTypeCOD: "货到付款",
        OrderTypePayLater: "稍后付款",
        OrderTypePartialPayment: "部分付款",
        OrderTypeSubscription: "订阅",
        viewAvailabilty: '查看可用时间',
        NotReceived: "未收货",
        NotShipped: "未发货",
        PartiallyReceived: "部分收货",
        PartiallyShipped: "部分发货",
    },
    PriceReference: {
        HighPrice: "最高价",
        LowPrice: "最低价",
        LastPrice: "最新价",
        LastPurchasePrice: "最新采购价格",
        Nopricerecordsfound: "未找到价格记录",
        BuyingPriceReference: "采购价参考",
        SellingPriceReference: "销售价参考",
        Viewstockinpricesfortheselectedvendorandproduct: "查看所选供应商和产品的入库价格",
        Viewstockoutpricesfortheselectedcustomerandproduct: "查看所选客户和产品的出库价格"
    },
    SubscriptionLocale: {
        premiumPlan: "高级方案",
        heading: "做出商业决策",
        headingHighlight: "基于数据",
        subtitle: "解锁您商业分析的全部力量 — 无限制，无妥协。",
        choosePlan: "选择您的方案",
        monthly: "按月",
        annual: "按年",
        oneTime: "一次性 (月租)",
        perMonth: "每月",
        perYear: "每年",
        bestValue: "最优价值",
        continueWith: "继续使用",
        perMonthShort: "月",
        perYearShort: "年",
        troubleWithSubscription: "订阅遇到问题？",
        contactUs: "联系我们",
        paymentNotReady: "支付未就绪",
        checkoutError: "结账错误",
        pricePreviewError: "价格预览错误",
        subNotAvailable: "订阅不可用",
        subNotAvailableDesc: "当前您所在的国家/地区无法使用网页订阅。请通过我们的移动应用订阅或联系我们获取帮助。"
    },
    SubscriptionLocale2: {
        GoPro: "升级到 Pro",
        Makesmarterdecisionsbackedbyrealbusinessdata: "基于真实业务数据做出更明智的决策",
        ExploreProPlans: "探索 Pro 方案"
    },
    emptyWarehouseState: {
        tips: [
            "您可以为不同物理位置设置多个仓库",
            "每个产品独立按仓库跟踪库存",
            '使用“仓库调拨”在不同位置之间移动库存'
        ],
        NoWarehousesConfigured: "未配置任何仓库",
        desc: "首先添加您的仓库（如果有多个），然后添加产品并记录库存变动。",
        WarehouseSetupTips: "仓库设置提示",
        Noproductselected: "未选择任何产品",
        Selectaproductfromthelefttoviewlowstockdetails: "从左侧选择产品以查看低库存详情。",
        Chooseaproductfromthelist: "从列表中选择产品",
        SelectProduct: "选择产品",
        SetQuantity: "设置数量",
        Showing: "显示",
        products: "产品",
        Continue: "继续",
        SaveSafetyStock: "保存安全库存",
        SafetyStockSaved: "安全库存已保存！",
        hasbeensetto: "已设置为",
        AddAnother: "添加另一个",
        Chooseaproduct: "选择产品",
        Step: "步骤",
        of: "的",
        Setsafetyquantity: "设置安全数量",
        Complete: "完成",
        SafetyStockQuantity: "安全库存数量",
        Minimumunitsdropsbelowthisnumber: "始终要在库存中保持的最小单位数。当库存低于此数字时会触发警报。",
        NewSafetyStock: "新的安全库存",
        SafetyNow: "当前安全库存",
        SettingTo: "正在设置为",
        Change: "更改",
        sell: "销售",
        cost: "成本",
        BulUD: "批量上传/删除"
    },
    SimplyLoginUI: {
        sslEncryption: "256位 SSL 加密",
        dataPrivate: "您的数据100%私密",
        worksOnDevices: "支持 Android 和 iPhone",
        realTimeSync: "所有设备实时同步",
        cloudBackup: "自动云备份",
        availableOn: "支持网页、Android 和 iOS",
        tagline: "您的库存，",
        taglineEm: "简洁而优雅。",
        subtitle: "登录即可管理库存、追踪销售，让您的业务顺畅运转 —— 一切尽在一处。",
        feature1Title: "实时库存追踪",
        feature1Desc: "准确掌握每个仓库的库存情况，始终保持最新。",
        feature2Title: "销售与采购订单",
        feature2Desc: "创建发票、管理供应商，并追踪每一笔交易。",
        feature3Title: "智能报表",
        feature3Desc: "财务、库存和每日动态报表一目了然。",
        feature4Title: "所有设备实时同步",
        feature4Desc: "手机上的更改会立即同步到网页 —— 反之亦然。",
        rating1: "评分",
        rating2: "4.9/5",
        rating3: "来自 10,000 家批发企业",
        brandName: "Simply",
        greeting: "欢迎回来！👋",
        noPasswordNeeded: "登录即可访问您的库存 —— Android、iPhone 和网页，完全同步。",
        badge1: "库存管理",
        badge2: "销售追踪",
        badge3: "报表",
        trustEncryptedTitle: "已加密",
        trustEncryptedSub: "256位 SSL",
        trustPrivateTitle: "私密",
        trustPrivateSub: "仅您的数据",
        trustBackedTitle: "已备份",
        trustBackedSub: "每日自动",
        availableOnLabel: "支持平台",
        platformAndroid: "Android",
        platformIphone: "iPhone",
        platformWeb: "网页",
        syncBadge: "所有设备实时即时同步",
        securityNote: "100% 安全。",
        securityDesc: "银行级加密保护您的所有数据。我们仅读取您的姓名和邮箱 —— 其他一无所知，永远如此。",
        signingIn: "正在登录…",
        termsPrefix: "登录即表示您同意 Simply 的",
        privacyPolicy: "隐私政策",
        and: "和",
        termsOfService: "服务条款",
        google: "使用 Google 登录"
    },
    BatchLocal: {
        BatchName: "批次名称",
        EnterBatchName: "输入批次名称",
        EnterNotes: "输入备注",
        ExpiredDate: "到期日期",
        Selectexpireddate: "选择到期日期",
        BatchStatus: "批次状态",
        CreatedDate: "创建日期",
        Areyousureyouwanttodeletethisbatch: "您确定要删除此批次吗？",
        Youhavencreatedanybatchforthisproduct: "您尚未为此产品创建任何批次。",
        Createyourfirstbatchtostarttrackingtockbylotexpiry: "创建您的第一个批次，开始按批次和到期日期跟踪库存。",
        Nobatchesyet: "暂无批次",
        Whatisbatchmanagement: "什么是批次管理？",
        Howithelpsyourbusiness: "它如何帮助您的业务",
        Trackbylotnumber: "按批号跟踪",
        Trackbylotnumberdesc: "按制造商批次对库存进行分组，以便您始终知道每个单位来自哪个批次。",
        Expirydatecontrol: "到期日期控制",
        Expirydatecontroldesc: "在库存到期前收到警报。先销售较旧的批次，自动减少浪费。",
        Fulltraceability: "完全可追溯性",
        Fulltraceabilitydesc: "查看每笔交易中使用了哪个批次 — 非常适合审计和召回。",
        Supplierwisestock: "按供应商划分库存",
        Supplierwisestockdesc: "即使是同一产品，也要将不同供应商的库存分开。按批次比较质量。",
        Createyourfirstbatchbutton: "创建您的第一个批次",
        Nomatchesfound: "未找到匹配项",
        NomatchesfounddescBefore: "我们找不到与 ",
        NomatchesfounddescAfter: " 匹配的任何批次。",
        Clearsearch: "清除搜索",
        Nohistoryfoundthisbatch: "此批次没有找到历史记录",
        ComprehensiveDetails: "详细信息",
        History: "历史记录",
        InBatch: "在批次中",
        Noproductfoundinthisbatch: "此批次中未找到产品",
        SelectBatch: "选择批次",
        available: "可用",
        Searchbatches: "搜索批次...",
        Expires: "到期",
        Nobatchesfound: "未找到批次",
        ManageBatches: "管理批次",
        Batchmanagement: "批次管理",
        Trackstockexpiry: "按批次和到期日期跟踪库存",
        Turnoffbatchmanagement: "关闭批次管理？",
        Yourgsafe: "您现有的批次数据将保持安全。",
        Reenableanytimefrom: "您可以随时从",
        Otherstab: "其他选项卡",
        AddBatch: "添加批次",
        Total: "总计",
        AssignProduct: "分配产品",
        EditProductAssignment: "编辑产品分配",
        AssignProducttoBatch: "将产品分配到批次",
        Updateproductconfiguration: "更新产品配置",
        Step1of2: "第 1 步，共 2 步",
        Step2of2: "第 2 步，共 2 步",
        Selectvariantwarehouse: "选择变体和仓库",
        SelectedProduct: "已选产品",
        AssignQuantity: "分配数量",
        BatchInfo: "批次信息",
        Wecouldnthisproductidentifier: "我们找不到与此产品标识符关联的任何批次。",
        NoActiveBatches: "没有活动批次",
        Endofresults: "结果结束",
        Expiry: "过期",
        BatchManagementDescription: "按批号和过期日期跟踪库存。确保每次出库时的 LIFO / FEFO 顺序正确 — 无需手动选择。",
        Expiryalerts: "过期提醒",
        Autonotifications: "自动通知",
        LIFOsorting: "LIFO / FEFO 排序",
        Smartstockflow: "智能库存流",
        Perout: "每批次出库",
        Precisiontracking: "精准跟踪",
        NeedsReview: "需要审核",
        Pending: "待处理",
        Rejected: "已拒绝",
        Approved: "已批准",
        WaitingForApproval: "等待批准",
        WaitingForApprovalDesc: "您的所有者将很快审核并批准此批次。",
        BatchRejected: "批次被拒绝",
        BatchRejectedDesc: "您的所有者拒绝了此批次。",
        Reason: "原因",
        Approve: "批准",
        Reject: "拒绝",
        ConfirmApproveTitle: "批准批次",
        ConfirmRejectTitle: "拒绝批次",
        ConfirmApprovalAction: "您确定要{action}此批次吗？此操作将更新其状态。",
        ReasonOptional: "原因（可选）",
        EnterReasonPlaceholder: "输入{action}的原因（可选）",
        Processing: "处理中...",
        BatchActivatedSuccess: "批次已成功激活",
        BatchDeactivatedSuccess: "批次已成功停用",
        BatchDeletedSuccess: "批次已成功删除",
        BatchApprovedSuccess: "批次已成功批准",
        BatchRejectedSuccess: "批次已成功拒绝",
        SearchByBatchName: "按批次名称搜索...",
        YesTurnOff: "是，关闭",
        KeepItOn: "保持开启"

    },
    CategoryNewL: {
        TotalCategories: "总类别数",
        lastaddedcategory: "上次添加的类别",
        acrossalltypes: "跨所有类型",
        MostRecent: "最近",
        YesD: "是的，删除",
        AllAssociated: "所有相关产品都可能受到影响"
    },
    OverDas: {
        movestockbetweenlocations: "移动库存",
        no_activity_yet: "暂无活动",
        no_activity_sub: "销售、采购、库存移动和退货将在这里实时显示。",
        make_first_sale: "进行首次销售",
        add_stock: "添加库存",
        all_stock_healthy: "所有库存水平正常",
        all_stock_healthy_sub: "没有商品即将缺货。请在商品上设置最低阈值以在此处接收提醒。",
        set_stock_thresholds: "设置库存阈值",
        no_warehouses_setup: "尚未设置任何仓库",
        no_warehouses_setup_sub: "添加一个仓库以开始跟踪您的库存存储位置并管理地点。",
        add_first_warehouse: "添加第一个仓库",
        Customer: "客户",
        PurchasevsSales: "采购 vs 销售",
        Financialperformancechart: "财务表现图表",
        QuickActions: "快速操作",
        Frequentlyused: "常用功能",
        Addinventory: "添加库存",
        Dispatchitems: "调拨商品",
        Addorder: "添加订单",
        Newitem: "新商品",
        Inventoryaccess: "库存访问",
        Itemsneedingreorder: "需要补货的商品",
        Latesttransactions: "最新交易",
        Operationalsummary: "运营摘要",
        ViewAll: "查看全部",
        Manage: "管理",
        RecentActivity: "最近活动",
        LowStockAlerts: "低库存提醒",
        Primary: "主要",
        TotalWarehouses: "仓库总数"
    },
    SerialLocal: {
        ShowOrHideFields: "显示或隐藏字段",
        ShowOrHideFieldsDesc: "点击下方的任何项目以将其包含在打印的发票中或从中删除。更改会立即生效。",
        Manufacturesettings: "制造设置",
        Showbuyingprice: "购买价 / 产品成本",
        Showadditionalcost: "额外费用",
        Costbreakdown: "费用明细",
        Unitcost: "单位成本",
        Rawmaterialstotal: "原材料总计",
        Confirmentry: "确认输入",
        SaveSerials: "保存序列号",
        SerialNumber: "序列号",
        selected: "已选择",
        added: "已添加",
        Serialnumbers: "序列号",
        ResetAll: "全部重置",
        Wecouldnfindthis: "未找到此产品的可用序列号。",
        Nounitsfound: "未找到任何单位",
        Searchingserialnumbers: "正在搜索序列号...",
        Scanorenterstock: "扫描或输入新库存的序列号",
        Whataserialnumber: "什么是序列号？",
        Auniqueidentifieryourinventorylifecycle: "每个单位的唯一标识符 — 可让您在整个库存生命周期中跟踪每个单独物品。",
        Trackedstockout: "已跟踪出库",
        Chooseexactlyselected: "请选择准确要出库的序列号。仅显示此产品已入库的序列号 — 选择后数量将锁定 ",
        SelectSerialstoout: " - 选择要出库的序列号",
        Thisinvoicegeneratedusingwwwsimplstockco: "此发票使用 www.simplstock.co 生成",
        AuthorizedSignature: "授权签名",
        Invoicesettings: "发票设置",
        Draw: "绘制",
        Taptoselectordeselectitems: "点击以选择或取消选择项目",
        Thissignaturewillbeadded: "此签名将添加到打印发票的底部。",
        SignatureOptions: "签名选项",
        Upload: "上传",
        DrawSignature: "手绘签名",
        UploadSignature: "上传签名",
        Clear: "清除",
        ShowStaffName: "员工姓名",
        ShowSKU: "SKU",
        ShowBusinessName: "公司名称",
        ShowProductName: "产品名称",
        ShowBusinessPhoneNumber: "业务电话号码",
        ShowBusinessEmail: "业务电子邮件",
        ShowBusinessAddress: "业务地址",
        ShowProductImage: "产品图片",
        ShowPaymentDetails: "付款详情",
        ShowCategory: "类别",
        ShowVariant: "规格",
        ShowWarehouse: "仓库",
        ShowAttributes: "属性",
        ShowQuantity: "数量",
        ShowDiscount: "折扣",
        ShowTax: "税费",
        ShowPrice: "价格",
        ShowTotalPrice: "产品总价",
        ShowExpenses: "费用",
        ShowSignature: "签名",
        ShowNote: "备注",
        showAttachment: "附件",
        ShowSerialNumber: "序列号",
        Invoicesettingsapplied: "发票设置已应用。请检查发票以查看更改。",
        EnterSerialNumber: "输入序列号",
    },
    FewLocal: {
        SelectBin: "选择货位",
        Live: "实时",
        Monitorinventorystocklevels: "监控库存、移动和库存水平",
        StockControlCentre: "库存控制中心",
        Nochartdataavailable: "暂无图表数据",
        Disabled: "已禁用",
        Enabled: "已启用"
    },
    Bin: {
        Bin: "货位",
        Add: "添加",
        NoBinsAddedYet: "尚未添加任何货位",
        BinLocationsHelp: "货位帮助您按照仓库内的精确位置跟踪库存 — 无需再搜索。",
        NameThemByPosition: "按位置命名：",
        AddBinLocation: "添加货位",
        BinLocations: "货位",
        BinNameRequired: "货位名称必填",
        EditBin: "编辑货位",
        AddBin: "添加货位",
        EnterBinName: "货位名称",
        EnterBinNamePlaceholder: "输入货位名称",
        BinStatus: "货位状态",
        BinNotes: "备注",
        EnterBinNotesPlaceholder: "添加一些备注...",
        ViewInventory: "查看库存",
        Inventory: "库存",
        TrymatchingadifferentSKUname: "尝试匹配其他SKU或名称。",
        Thisbinlocationcurrentlyempty: "此货位当前为空。",
        Loadingbins: "正在加载货位...",
        bins: "货位",
        ManageBin: "管理货位",
        Print: "打印",
        SBin: "源储位",
        DBin: "目的地储位"
    },
    WarehouseExcel: {
        title: "上传仓库 & 货位",
        description: "按照以下步骤使用Excel文件批量创建仓库及其货位。",
        bulkUploadGuide: "批量上传指南",
        step1: "步骤 1",
        downloadTemplate: "下载Excel模板",
        downloadTemplateDesc: "下载已预置所有必要列标题的官方模板。请勿重主名或删除任何列。",
        downloadTemplateBtn: "下载模板",
        step2: "步骤 2",
        fillExcelFile: "填写Excel文件",
        fillExcelDesc: "每行代表一个仓库。请填写所有列 — 对于货位，请在 <code>Bin Names</code> 列中用逗号分隔输入所有货位名称。",
        step3: "步骤 3",
        thingsToKeepInMind: "注意事项",
        rulesDesc: "上传前，请确保您的文件符合以下规则。",
        step4: "步骤 4",
        uploadYourFile: "上传您的文件",
        uploadDesc: "填写完成后，上传下方文件。系统将自动创建所有仓库和货位。",
        rules: ["每个仓库仅一行", "货位名称用逗号分隔在一个单元格内", "请勿修改列标题名称", "同一仓库内重复的货位名称将被跳过", "带国家代码的电话号码", "仅支持 .xlsx 或 .xls 文件"],
        dropFileHere: "将Excel文件拖放到此处",
        supports: "支持 .xlsx 和 .xls — 最大 10 MB",
        chooseFileUpload: "选择文件并上传",
        parsing: "正在解析文件...",
        invalidFileType: "文件类型无效。请上传Excel文件。",
        noData: "Excel中未找到数据",
        failedToRead: "无法读取Excel文件",
        unableToRead: "无法读取文件。",
        reviewTitle: "审核仓库数据",
        reviewSubtitle: "导入到您的业务前的最终检查。",
        changeFile: "更改文件",
        rowsFound: "行已找到",
        cancel: "取消",
        finalizeImport: "完成并导入",
        importing: "正在导入...",
        success: "成功",
        allWarehouseUploadedSuccess: "所有仓库已成功上传",
        failed: "失败",
        bulkUploadFailed: "批量上传失败",
        error: "错误",
        binNamesNote: "在 <strong>Bin Names</strong> 列中，将一个仓库的所有货位名称用逗号分隔输入到一个单元格中 — 例如：A1, A2, B1, RACK-01。",
        headers: { warehouseName: "仓库名称", email: "邮箱", phoneNumber: "电话号码", location: "位置", binNames: "货位名称" }
    },
    VariantTemplate: {
        VariantTemplates: "变体模板",
        Managereusablevariantpatterns: "管理可重复使用的变体模式",
        BinTransferHistory: "货位转移记录",
        Trackmovementsacrossbins: "跟踪货位之间的移动",
        SerialNumberHistory: "序列号记录",
        Trackproductserialnumberactivity: "跟踪产品序列号活动",
        Period: "时间段",
        Nohistoryfound: "未找到记录",
        Searchserialnumbers: "搜索序列号...",
        SerialNumbersHistory: "序列号历史",
        Serialnumberhistoryglance: "序列号历史一览。",
        Noserialnumbersfound: "未找到序列号",
        Noactivityhistoryfound: "未找到活动记录",
        Statussetto: "状态设置为",
        Timeline: "时间线",
        Managereusableproductvariantpatterns: "管理可重复使用的产品变体模式。",
        DeleteTemplate: "删除模板",
        Areyousureyouwanttemplate: "确定要删除此模板吗？",
        CreateNewTemplate: "创建新模板",
        CreateTemplate: "创建模板",
        EditTemplate: "编辑模板",
        UnlimitedTemplates: "无限模板",
        CreateAsManyTemplates: "根据需要创建任意数量的模板 — 服装、鞋类、电子产品等。",
        PickWhileAddingProduct: "添加产品时选择",
        OpenTemplateLibrary: "打开模板库，几秒内选择变体名称。",
        MixFromMultipleTemplates: "从多个模板混合",
        SelectFromMultipleTemplates: "为单个产品从多个模板中选择变体名称 — 完全灵活。",
        EditAnytime: "随时编辑",
        RenameTemplatesAnytime: "随时重命名模板、添加或删除变体名称。",
        StayConsistent: "保持一致性",
        SameVariantNamesAcrossAll: "所有产品使用相同的变体名称。无错别字、无重复、无猜测。",
        BuildOnceUseEverywhere: "一次创建， 处处使用",
        StopReEnteringVariantNames: "停止为每个产品重复输入相同的变体名称。创建一次模板，即可立即重复使用。",
        Updateexistingvariantcombinations: "更新现有变体组合",
        Definenewvariantcombinations: "定义新的变体组合",
        TemplateName: "模板名称",
        AddVariantOptions: "添加变体选项",
        SmallMedium: "例如：小号、中号...",
        VariantsList: "变体列表",
        Nooptionsaddedyet: "尚未添加任何选项",
        SaveTemplate: "保存模板",
        egSizesColorsetc: "例如：T恤尺码、颜色等",
        Pleaseentertemplatename: "请输入模板名称",
        Pleaseaddatleastonevariantoption: "请至少添加一个变体选项",
        Templateupdatedsuccessfully: "模板更新成功",
        Templatecreatedsuccessfully: "模板创建成功",
        Failedtosavetemplate: "保存模板失败",
        Transfer: "转移",
        Editassignment: "编辑分配",
        Updateproductdetailsinbin: "更新货位中的产品信息",
        Editinginbin: "正在货位中编辑",
        ConfirmUpdate: "确认更新",
        ConfirmAssign: "确认分配",
        Assignanotherproduct: "分配其他产品",
        TransferBin: "转移货位",
        SourceBin: "源货位",
        DestinationBin: "目标货位",
        SelectSourceBin: "选择源货位",
        SelectDestinationBin: "选择目标货位",
        Unit: "单位",
        ManageVariant: "管理变体",
        CreateSKUvariationsyourproduct: "为您的产品创建SKU变体",
        Assigningvariationsto: "正在分配变体至",
        Novariantsaddedyet: "尚未添加任何变体",
        AddedVariants: "已添加变体",
        AddVariantsfromTemplate: "从模板添加变体",
        Pickatemplateandselectvariantnames: "选择模板并选择变体名称",
        ChooseaTemplate: "选择模板",
        Selectvariantnamestoadd: "选择要添加的变体名称",
        SelectatemplatetopickvariantnamesfroYoucanaddfrommultiple: "选择一个模板来挑选变体名称。您可以从多个模板中添加。",
        Loadingtemplates: "正在加载模板...",
        Backtotemplates: "返回模板列表",
        Selectallindividualadd: "全选或单独选择变体名称添加。",
        VariantNames: "变体名称",
        MediaDescription: "媒体 & 描述",
        Addattachmentsandproductnotes: "添加附件和产品备注",
        ProductMedia: "产品媒体"
    },
    AddProductGuide: {
        title: "保存后添加初始数量",
        description: "产品在此没有数量字段。保存后，使用“入库”记录您的期初库存 — 对位置和追踪拥有完全控制权。",
        steps: {
            quantity: { title: "数量", sub: "设置期初库存数量" },
            binLocation: { title: "货位", sub: "通道、货架、层架 — 例如：A-01-03" },
            serialNumbers: { title: "序列号", sub: "单独追踪每个单位" },
            warehouse: { title: "仓库", sub: "存储在哪个位置" },
            batchExpiry: { title: "批次 / 有效期", sub: "按批次号对库存分组" }
        },
        actions: { close: "关闭" }
    },
    Remainingtranferitems: {
        NoTransferOrdersFound: "未找到调拨单",
        Itemshistory: "您在仓库之间转移的物品将在这里显示，用于跟踪和历史记录。",
        CreateTransfer: "创建调拨"
    },
    ManufactureLocal: {
        TaponproducttoManufacture: "点击产品进行制造",
        Selectproductfrombelow: "从下方列表中选择产品",
        SetupANewProduct: "设置新产品",
        DefineAProductAdditsrawmaterial: "定义产品并添加其原材料",
        ManufacturingSetup: "制造设置",
        Pickproducttodefineitsproductiondetails: "选择产品以定义其生产详情",
        ConfigureManufacturing: "配置制造",
        SelectRawMaterial: "选择原材料",
        NoRawMaterials: "无原材料",
        Definecomponentsneededtoproduct: "定义制造此产品所需的组件。",
        NoAdditionalCosts: "无额外成本",
        Addlaboroverheadlogisticalcharges: "添加人工、间接费用或物流费用。",
        AddAdditionalCost: "添加额外成本",
        AddCost: "添加成本",
        TotalPrice: "总价",
        SelectCharges: "选择费用",
        EnterEstimatedCost: "输入估计成本",
        QtyRequried: "所需数量",
        Manufacturing: "制造",
        Outputfinishedgoodsdestination: "成品目的地",
        Manufacturingquantity: "制造数量",
        Storefinishedgoodsat: "将成品存放在",
        Rawmaterials: "原材料",
        StockSelection: "库存选择",
        AdditionalCosts: "额外成本",
        Quantityconsume: "消耗数量",
        Totalmanufacturingcost: "总制造成本",
        Sumofrawmaterialcosts: "所有原材料成本的总和",
        CustomManufacturingCharge: "自定义制造费用",
        Addextralikelaboroverheadrepairs: "添加额外费用，如人工、间接费用或维修。",
        CalculatedTotal: "计算总额",
        AddRawMaterial: "添加原材料",
        ConfigureRawMaterial: "配置原材料",
        Thisoutputunit: "这是每单位产出所需的基础数量。",
        ChangeProduct: "更换产品",
        AddtoList: "添加到列表",
        ManufacturedSuccessfully: "制造成功",
        Manufacture: "生产",
        EditDeleteHistory: "编辑/删除记录",
        ManageOrder: "管理订单",
        ManageBatch: "管理批次",
        Paymentnotavailablehere: "此处无法付款",
        Thisrecordisanorderorderitself: "此记录来自订单。只能从订单本身记录付款。",
        Torecorpaymenttheorderthethere: "要记录付款，请前往关联订单并在那里使用<b>记录付款</b>选项。",
        GotoOrder: "转到订单"
    },
    CustomerExcel: {
        title: "上传客户",
        description: "按照以下步骤使用 Excel 文件批量创建客户。",
        bulkUploadGuide: "批量上传指南",
        step1: "第 1 步",
        downloadTemplate: "下载 Excel 模板",
        downloadTemplateDesc: "获取预先配置了所有必需列标题的官方模板。",
        downloadTemplateBtn: "下载模板",
        step2: "第 2 步",
        fillExcelFile: "填写 Excel 文件",
        fillExcelDesc: "每一行代表一个客户。按要求填写所有列。",
        step3: "第 3 步",
        thingsToKeepInMind: "注意事项",
        rulesDesc: "上传前，请确保您的文件遵循这些规则以避免错误。",
        step4: "第 4 步",
        uploadYourFile: "上传您的文件",
        uploadDesc: "填写完成后，在下方上传文件。系统将自动创建所有客户。",
        rules: [
            "每行仅限一个客户",
            "请勿重命名列标题",
            "带国家代码的联系电话",
            "仅接受 .xlsx 或 .xls 文件"
        ],
        dropFileHere: "将 Excel 文件拖放到此处",
        supports: "支持 .xlsx 和 .xls — 最大 10 MB",
        chooseFileUpload: "选择文件并上传",
        parsing: "正在解析文件...",
        invalidFileType: "文件类型无效。请上传 Excel 文件。",
        noData: "在 Excel 中未找到数据",
        failedToRead: "读取 Excel 文件失败",
        unableToRead: "无法读取文件。",
        reviewTitle: "审核客户数据",
        reviewSubtitle: "导入您的业务前的最后检查。",
        changeFile: "更改文件",
        rowsFound: "在文件中找到行",
        cancel: "取消",
        finalizeImport: "完成并导入",
        importing: "正在导入...",
        success: "成功",
        allCustomerUploadedSuccess: "所有客户已成功上传",
        failed: "失败",
        bulkUploadFailed: "批量上传失败",
        error: "错误",
        headers: {
            customerName: "客户名称",
            phoneNumber: "联系方式",
            address: "地址",
            note: "备注"
        }
    },
    SupplierExcel: {
        title: "上传供应商",
        description: "按照以下步骤使用 Excel 文件批量创建供应商。",
        bulkUploadGuide: "批量上传指南",
        step1: "第 1 步",
        downloadTemplate: "下载 Excel 模板",
        downloadTemplateDesc: "获取预先配置了所有必需列标题的官方模板。",
        downloadTemplateBtn: "下载模板",
        step2: "第 2 步",
        fillExcelFile: "填写 Excel 文件",
        fillExcelDesc: "每一行代表一个供应商。按要求填写所有列。",
        step3: "第 3 步",
        thingsToKeepInMind: "注意事项",
        rulesDesc: "上传前，请确保您的文件遵循这些规则以避免错误。",
        step4: "第 4 步",
        uploadYourFile: "上传您的文件",
        uploadDesc: "填写完成后，在下方上传文件。系统将自动创建所有供应商。",
        rules: [
            "每行仅限一个供应商",
            "请勿重命名列标题",
            "带国家代码的联系电话",
            "仅接受 .xlsx 或 .xls 文件"
        ],
        dropFileHere: "将 Excel 文件拖放到此处",
        supports: "支持 .xlsx 和 .xls — 最大 10 MB",
        chooseFileUpload: "选择文件并上传",
        parsing: "正在解析文件...",
        invalidFileType: "文件类型无效。请上传 Excel 文件。",
        noData: "在 Excel 中未找到数据",
        failedToRead: "读取 Excel 文件失败",
        unableToRead: "无法读取文件。",
        reviewTitle: "审核供应商数据",
        reviewSubtitle: "导入您的业务前的最后检查。",
        changeFile: "更改文件",
        rowsFound: "在文件中找到行",
        cancel: "取消",
        finalizeImport: "完成并导入",
        importing: "正在导入...",
        success: "成功",
        allSupplierUploadedSuccess: "所有供应商已成功上传",
        failed: "失败",
        bulkUploadFailed: "批量上传失败",
        error: "错误",
        headers: {
            supplierName: "供应商名称",
            phoneNumber: "联系方式",
            bankName: "银行名称",
            accountHolderName: "账户持有人姓名",
            accountNumber: "账号",
            note: "备注"
        }
    },
    ReplaceReturnLocal: {
        ReplacedWith: "更换为",
        Noreplacementhistoryfound: "未找到更换记录",
        Noreturnhistoryfound: "未找到退货记录",
        Productbeingreturned: "退回的产品",
        Required: "必填",
        Selectreturnedproduct: "选择退回的产品",
        Searchnamescanbarcode: "按名称、SKU 搜索或扫描条形码",
        Browse: "浏览",
        Stockhandling: "入库处理",
        Stockinreturnedproduct: "将退回产品入库",
        Ontoinventory: "开启 — 退回物品将重新添加至库存",
        Offreturnedonly: "关闭 — 物品仅记录为退回",
        Usedrestock: "用于计算补货时的利润调整",
        Willaddedbackconfirmation: "确认后将重新添加至库存",
        Returnreason: "退货原因",
        Optional: "选填",
        SelectReason: "选择原因",
        Additionalnotes: "补充备注",
        Describeofcustomerexplanation: "描述退回物品的状态、任何明显的损坏、客户的解释等...",
        Requiredmustfilledcontinue: "必须填写必填字段才能继续",
        Reviewdetailsbeforeconfirming: "确认前请检查详情",
        Replacementproductwilldeductedinventoryconfirmation: "确认后，更换产品将从您的库存中扣除。",
        Choosereplacementproduct: "选择更换产品",
        Willdeductedfrominventoryconfirm: "确认后将从库存中扣除",
        Thesewillattachedothereturnrecord: "这些图片将附在退货记录中",
        Replacementitem: "更换物品",
        Addanotherproduct: "添加另一个产品",
        Replacementproductwillbe: "更换产品将在确认后",
        deducted: "扣除",
        fromyourinventoryconfirmation: "自您的库存中。",
        productadjustedusingprice: "退回的产品将重新入库，并使用原销售价格调整利润。",
        Willloggedreturnedonlynotrestocked: "仅记录为退回 — 不重新入库",
        Returnonly: "仅退货",
        Imagesofreturnedproduct: "退回产品的图片",
        Returnedproductwill: "退回的产品",
        not: "不会",
        berestockedloggedreturnedonly: "重新入库 — 仅记录为退回。",
        AddImage: "添加图片",
        STOCKIN: "入库",
        LOGONLY: "仅记录",
        ContinuetoReview: "继续检查 →",
        Confirmreplacement: "确认更换",
        Confirmreturn: "确认退货",
        Filldetailsbelowproceed: "请填写以下详情以继续",
        Review: "检查",
        editdetails: "编辑详情",
        Configurereturndetails: "配置退货详情",
        Configurereplacementdetails: "配置更换详情",
        SelectSource: "选择来源",
        Returning: "退货中",
        Replacement: "更换",
        WalkCustomer: "散客",
        RETURNEDPRODUCT: "退回产品",
        REPLACEMENTPRODUCT: "更换产品",
        STOCKOUT: "出库",
        Netinventoryimpact: "净库存影响",
        Replacementitemcost: "更换物品成本",
        Returneditemrestockvalue: "退回物品入库价值",
        PROFITINVENTORYSUMMARY: "利润与库存摘要",
        Inventoryaction: "库存操作",
        Valuededucted: "扣除价值",
        Profitadjustment: "利润调整",
        stockedout: " 已出库",
        restocked: " 已入库",
        Noaction: "无操作",
        Valuebeingreturned: "退回价值",
        Willberestocked: "将入库",
        Willbe: "将",
        logged: "记录",
        ON: "开启",
        OFF: "关闭",
        Linked: "已关联",
        Pleaseselectreturnedproduct: "请选择退货产品",
        Quantityrequired: "数量为必填项",
        Buyingpricerequired: "采购价为必填项",
        Pleaseaddleastreplacementproduct: "请至少添加一个替换产品",
        Pleaseconfigurereturnedproductdetails: "请配置退货产品详情",
        Pleaseselectcustomer: "请选择客户",
        Returndateisrequired: "退货日期为必填项",
        Pleasefillallrequiredfields: "请填写所有必填字段",
        Wildeductedfrominventory: "将从库存中扣除",
        Currentprice: "当前价格",
        Defectivedamaged: "有缺陷 / 损坏",
        Wrongitemreceived: "收到错误商品",
        Customerchangedmind: "顾客改变主意",
        Sizefitissue: "尺寸 / 合身问题",
        Notasdescribed: "与描述不符",
        Other: "其他",
        Originalsaleprice: "原始销售价格（利润调整）",
        Addedbackinventory: "已重新加入库存",
        Notaddedinventory: "未加入库存",
        replacedwith: "替换为",
        deductedfrominventory: "从库存中扣除",
        RETURNWITHSTOCKIN: "退货 · 库存入",
        RETURNNOSTOCKIN: "退货 · 无库存入",
        MULTIPLEREPLACEMENTS: "多次更换",
        SINGLEREPLACEMENT: "单次更换",
        InternalTrackingRecordInfo: "This is a record for internal tracking. This process DOES NOT automatically update or delete related invoices, orders, or accounts.",
        ManualStepsIfNeeded: "Manual Steps (if needed):",
        ManualStep1: "Return/Delete invoice from Sale History",
        ManualStep2: "Adjust customer ledger manually",
        ManualStep3: "Update related purchase record",
        RETURNEDSTOCKIN: "已退回 · 库存入",
        REPLACEMENTSTOCKOUT: "更换 · 库存出",
        Returnonlylogsthisentry: "退货仅记录此条目 —",
        nostockwillbeaddedorremoved: "不会增加或移除库存",
        frominventory: "从库存中。",
        Whentousethis: "何时使用此功能：",
        UseReturnenddayrecorditemsoutsalesthatcamebackunusablewantinventory: "在一天结束时使用“仅退货”来记录因销售而发出的物品，但在退回时已损坏或无法使用 — 您想要跟踪但无法重新加入库存的物品。",
        Youcanviewallpastreturnentriesin: "您可以在以下位置查看所有过去的退货记录：",
        ReturnHistory: "退货历史",
        underthe: "在",
        Others: "其他",
        tab: "选项卡下。",
        Negativestocktransactiondisabled: "负股票交易已被禁用。"
    },
    NewRLocal: {
        Originalsaleprice: "原始销售价格",
        Editinghistoryonlyinventorystaysunchanged: "仅编辑历史记录 — 库存保持不变。",
        Changeshereupdatethisdetailsquantitiesaffected: "此处的更改仅更新此记录的详细信息（原因、日期、备注）。您的实际库存数量、货位和产品数据不会受到影响。",
        Needtofixinventorylevelsinstead: "需要改为修正库存水平吗？",
        AdjustStock: "调整库存",
        Refund: "退款",
        ImportantNote: "重要提示",
        Pleasereviewbeforecontinuing: "请在继续之前查看",
        Onceshippedreceivedanyupdatesmadeorder: "订单一旦发货或接收，对订单所做的任何更新都不会反映在交易历史记录中。",
        Thisundone: "这将永久移除订单。此操作无法撤销。",
        Inventorywilladjustedautomatically: "库存不会自动调整",
        Deletingthisreversevedshippedyouwillneed: "删除此操作不会撤销任何库存更改。如果物品已接收/发货，您将需要",
        reflectthecorrectstocklevels: "以反映正确的库存水平。",
        manuallyadjustyourinventory: "手动调整您的库存",
        Addremovestockforitemsthatwereshipped: "为已发货物品添加/移除库存",
        Addremovestockforitemsthatwerereceived: "为已接收物品添加/移除库存",
        Updatecostrecordspaymentwaalreadymade: "如果已付款，请更新成本记录",
        Reconcilerecordsandoutstandingpayments: "核对记录和未付账款"
    },
    ReceivablesLocal: {
        Receivables: "应收账款",
        Manageandtrackcustomerduebalances: "管理并跟踪客户到期余额",
        Viewcustomerduebalancereport: "查看客户到期余额报告",
        Viewsupplierduebalancereport: "查看供应商到期余额报告",
        DueBalance: "到期余额",
        Unpaid: "未付款",
        PartiallyPaid: "部分付款",
        Paid: "已付款",
        HighestBalance: "最高余额",
        LowestBalance: "最低余额",
        Filldetailsrecordpayment: "填写详细信息以记录付款",
        NewPaymentEntry: "新建付款记录",
        EditPaymentEntry: "编辑付款记录",
        Nosuppliersfound: "未找到供应商",
        Nocustomersfound: "未找到客户",
        LowtoHigh: "低到高",
        HightoLow: "高到低",
        AttachmentUploadedSc: "附件上传成功",
        AttachmentUploadedF: "附件上传失败",
        Pay: "支付",
        NoBillsFound: "未找到账单",
        Thiscustomerhasunpaidbills: "该客户没有未付账单。",
        TotalDue: "总计到期",
        BillsFound: "找到账单",
        DeselectAll: "取消全选",
        SelectAll: "全选",
        ShowDetails: "显示详情"
    },
    AssetsNewLocal: {
        Assignedon: "分配于",
        Total: "总计",
        Assigned: "已分配",
        Remaining: "剩余",
        Available: "可用",
        NoSerialNumbers: "无序列号",
        UpdateExistingAssetDetails: "更新现有资产详情",
        RegisterNewBusinessAsset: "注册新的业务资产",
        BasicInformation: "基本信息",
        AssetDetails: "资产详情",
        Quantity: "数量",
        SerialNumbers: "序列号",
        SerialNumberPlaceholder: "序列号",
        AddSerialNumber: "添加序列号",
        SerialNumbersOptional: "序列号为选填项。您最多可以添加",
        AssetImages: "资产图片",
        AdditionalNotes: "备注",
        AdditionalNotesPlaceholder: "任何其他详情或维护历史...",
        Updating: "更新中...",
        Adding: "添加中...",
        ITEquipmentPlaceholder: "例如：IT设备",
        LoadingMoreActivities: "正在加载更多活动...",
        AssignedAssets: "已分配资产",
        Noassetsassignedstaffmember: "该员工没有分配任何资产。",
        Assignassetstaff: "分配资产给员工",
        Returnassetfromstaff: "从员工处归还此资产",
        AssignmentDetails: "分配详情",
        Serial: "序列号",
        ViewAssets: "查看所有资产",
        ViewByStaff: "按员工查看",
        AssignedHistory: "分配历史",
        Returned: "已归还",
        Returnedon: "归还日期",
        ReturnedBy: "归还人",
        AssignedTo: "分配给",
        NoHistoryRecords: "没有历史记录",
        Selectstaffmemberviewtheirassets: "选择一名员工查看其资产",
        Deleted: "已删除",
        searchPlaceholder: "按名称或序列号搜索资产..."
    },
    InventoryCountLocale: {
        InventoryCount: "库存盘点",
        Viewinventorycountreport: "查看库存盘点报告",
        ItemsCount: "商品数量",
        All: "全部",
        InProgress: "进行中",
        Submitted: "已提交",
        awaitingreview: "等待审核",
        EditInventoryCount: "编辑盘点",
        NewInventoryCount: "新建盘点",
        Modifyinventorycountsheetdetails: "修改盘点表详情",
        Startanewinventorycountsheet: "开始新的盘点表",
        GeneralInformation: "基本信息",
        Title: "标题",
        SaveChanges: "保存更改",
        Selectproductsforthisinventorycountsheet: "选择本次盘点的产品",
        InventoryCountDetails: "盘点详情",
        Inventorycountsheetdetails: "盘点表详情",
        Viewingdetailsforcountsheet: "正在查看盘点表详情",
        Started: "已开始",
        TaskSheets: "任务表",
        Allitems: "所有商品",
        NotStarted: "未开始",
        Completed: "已完成",
        Results: "结果",
        ViewResults: "查看结果",
        DeleteInventoryCount: "删除盘点",
        Viewingtransactionandadjustments: "查看交易记录和库存调整",
        Productsadjusted: "已调整产品",
        Assignee: "负责人",
        Tasksheetdetails: "任务表详情",
        Draft: "草稿",
        VariantQuantities: "变体数量",
        AssignedProducts: "已分配产品",
        ReturnAsset: "归还资产",
        EditTasksheet: "编辑任务表",
        NewTasksheet: "新建任务表",
        Updatetasksheetdetails: "更新任务表详情",
        Starttasksheetforthisinventorycount: "为此盘点开始新的任务表",
        TaskSheetInformation: "任务表信息",
        SheetTitle: "表标题",
        Entersheettitle: "输入表标题",
        SubmissionResult: "提交结果",
        ReviewChanges: "审核变更",
        Viewingsubmissionresultsforthisinventorycount: "查看此盘点的提交结果",
        Reviewyourinventorycountbeforesubmitting: "提交前请检查您的库存盘点"
    },
    NewMissingLocale: {
        Failedtoloadcounts: "加载盘点失败",
        NoInventoryCounts: "没有库存盘点",
        NoMatches: "没有匹配项",
        Therearenoinventorycountswiththestatus: "没有此状态的库存盘点",
        Noinventorycountsfoundyoursearchterm: "未找到匹配您搜索词的库存盘点",
        Thereareinventorycountsrecordedyetforthisbusiness: "此业务尚未记录任何库存盘点"
    },
    StockinModalP: {
        StockInNow: "立即入库",
        Settheopeningquantityforthisproductrightnow: "立即设置此产品的初始数量。",
        Addinitialstock: "添加初始库存？",
        dothislater: "稍后操作",
        Productadded: "商品添加成功！",
        isready: "已就绪。",
        SeeHowItWorks: "查看工作原理",
        NoSalesOrdersFound: "未找到销售订单",
        NoPurchaseOrdersFound: "未找到采购订单",
        Startcreatingoutgoinginventoryrevenue: "开始创建销售订单以跟踪出库库存和收入。",
        Trackrestockssupplierplace: "在一个地方跟踪库存补货和供应商订单。",
        CreateSalesOrder: "创建销售订单",
        CreatePurchaseOrder: "创建采购订单",
    }
    ,
    dialy_report: "每日变动报告",
    Quotation: "报价",
    Quote: "报价",
    Assignee: "负责人",
    dayStart: "一天开始",

    ShowTotalAmount: "总金额",


    tutorial: {
        watchTitle: '观看分步教程',
        watchDesc: '在我们的YouTube频道上了解SimplyStock',
        modalTitle: '使用SimplyStock保持领先地位',
        modalDesc: '订阅即可在新教程下架时获得新教程',
        feature1Title: '新功能演练',
        feature1Sub: '每次更新都会通过一段简短的视频进行解释，这样您就不会错过新功能',
        feature2Title: '快速操作视频',
        feature2Sub: '在5分钟内设置库存、发票、员工访问权限等',
        feature3Title: '立即通知',
        feature3Sub: '在新教程上线时获得通知—按照自己的节奏学习',
        feature4Title: '始终100%免费',
        feature4Sub: '所有教程都是永久免费的—无需登录或订阅',
        subscribeBtn: '订阅SimplyStock',
        maybeLater: '以后再说'
    }
    ,
    dailyCashReport: {
        "title": "每日现金报表",
        "subtitle": "谁在什么日期支付了什么，还有什么未付 — 根据销售明细汇总。",
        "totalSales": "总销售额",
        "cashReceived": "总共收到",
        "outstanding": "未结清",
        "collectionRate": "收款率",
        "grandTotalAllDates": "总计（所有日期）",
        "totalLabel": "总计",
        "loading": "加载中...",
        "noData": "未找到选定日期范围的数据。",
        "loadingMore": "加载更多..."
    },
    dailyCashReportColumns: {
        "date": "日期",
        "customer": "客户",
        "productsSold": "售出产品",
        "products": "产品",
        "salesAmount": "销售金额",
        "sales": "销售",
        "received": "总共收到",
        "receivedShort": "已收",
        "debited": "借记到分类账",
        "due": "应付",
        "paymentModes": "支付方式",
        "mode": "方式"
    }
}



export default zh
